'use strict';

import axios from 'axios';

export default (config) => {
  const role = localStorage.getItem('role');
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = `https://stampserver.manzilak.net/${role ? role : 'client'}`; //`https://stampserver.manzilak.net/${role ? role : 'client'}`

  const path = config.path || '';
  const method = config.method || 'get';
  let headers = {}
  if (config.contentType) {
    headers = { 'Content-Type': config.contentType };
  } else {
    headers = { 'Content-Type': 'application/json' }
  }
  if (config.recaptcha) {
    headers = { ...headers, 'x-xbuffer-recaptcha': config.recaptcha };
  }
  const sendRequest = {
    headers: headers,
    url: path,
    method: method
  }
  if (method === 'get') {
    sendRequest.params = config.data;
  } else {
    sendRequest.data = config.data;
  }
  if (config.responseType) {
    sendRequest.responseType = config.responseType;
  }
  return axios(sendRequest);
}
